import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header.vue'
import Sidebar from './Sidebar.vue'
import Switch from './Switch.vue'
import DateTimePicker from './DateTimePicker.vue'
import MyModal from './MyModal.vue'

export {
  Aside,
  Breadcrumb,
  Callout,
  Footer,
  Header,
  Sidebar,
  Switch,
  DateTimePicker,
  MyModal
}



// WEBPACK FOOTER //
// ./src/components/index.js